import { VehicleDetailsGroupOutput } from './vehicle-details-group-output.model';


export class VehicleGroupWithoutStatusOutput implements IVehicleGroupWithoutStatusOutput {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id!: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The description with 500 character limit */
    description!: string;
    vehicle_details_group!: VehicleDetailsGroupOutput[];
    status!: number;

    constructor(data?: IVehicleGroupWithoutStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_group_id = _data["vehicle_group_id"];
            this.vehicle_group_name = _data["vehicle_group_name"];
            this.company_details_id = _data["company_details_id"];
            this.description = _data["description"];
            if (Array.isArray(_data["vehicle_details_group"])) {
                this.vehicle_details_group = [] as any;
                for (let item of _data["vehicle_details_group"])
                    this.vehicle_details_group!.push(VehicleDetailsGroupOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleGroupWithoutStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleGroupWithoutStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_group_id"] = this.vehicle_group_id;
        data["vehicle_group_name"] = this.vehicle_group_name;
        data["company_details_id"] = this.company_details_id;
        data["description"] = this.description;
        if (Array.isArray(this.vehicle_details_group)) {
            data["vehicle_details_group"] = [];
            for (let item of this.vehicle_details_group)
                data["vehicle_details_group"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleGroupWithoutStatusOutput {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The description with 500 character limit */
    description: string;
    vehicle_details_group: VehicleDetailsGroupOutput[];
    status: number;
}

